import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { NumericFormat } from "react-number-format";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AccountManagerService from "../../services/Celcoin/accountManagerService";
import StaticCashInService from "../../services/Celcoin/staticChargeCashInService";
import KeysManagementService from "../../services/Celcoin/keysManagementService";
import { getTranslations } from "../../services/languageUtils";
import { isMutual } from "../../utils/isMutual";
import { isMtBank } from "../../utils/isMtBank";

const FIXED_BANK_CODE = "33.630.661";
const DEPOSIT_QR_BLOCKED_EMAILS = [
  "higher.otc.adm@higherglobal.com.br",
  "higher.bxin.adm@higherglobal.com.br",
  "higher.otc.api.adm@higherglobal.com.br",
];
const DEPOSIT_QR_BLOCKED_ACCOUNTS = [
  "71278676016710101005",
  "36580026347710101003",
  "20712166477710101000",
];
const DEPOSIT_QR_BLOCKED_PIX_KEYS = [
  "16af3f00-f9fd-4d12-88db-8b61099ed854",
  "e4f37a4c-2751-4b10-b05e-529c804f2e8d",
  "c81370ec-dba1-42a4-ae82-34d3d4657b16",
];

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: "",
      account: "",
      pixKey: "",
      hasPixKey: false,
      qrCode: "",
      qrCodeImageBase64: "",
      listKeys: [],
      amount: 100,
      translations: {},
      load: false,
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.setState({ load: true });
    this.updateData();
    this.loadTranslations();
  }

  isDepositQrBlocked = (pixKey = this.state.pixKey) => {
    const email = (sessionStorage.getItem("emailUser") || "").toLowerCase();
    const account =
      sessionStorage.getItem("account") || this.state.account || "";
    const normalizedPixKey = (pixKey || "").toLowerCase();

    return (
      DEPOSIT_QR_BLOCKED_EMAILS.includes(email) ||
      DEPOSIT_QR_BLOCKED_ACCOUNTS.includes(account) ||
      DEPOSIT_QR_BLOCKED_PIX_KEYS.includes(normalizedPixKey)
    );
  };

  async updateData() {
    const account = sessionStorage.getItem("account") || "";
    const branch = sessionStorage.getItem("agency") || "";

    this.setState({ account, branch });

    try {
      const keyResponse = await KeysManagementService.index();
      const listKeys = Array.isArray(keyResponse?.data)
        ? keyResponse.data
        : keyResponse?.data?.body?.listKeys || [];
      const activePixKey = listKeys[0]?.key || "";

      this.setState({
        listKeys,
        pixKey: activePixKey,
        hasPixKey: !!activePixKey,
      });

      if (this.isDepositQrBlocked(activePixKey)) {
        this.setState({ qrCode: "", qrCodeImageBase64: "", load: false });
        return;
      }

      if (!activePixKey) {
        this.setState({ qrCode: "", qrCodeImageBase64: "", load: false });
        return;
      }

      const qrResponse = await StaticCashInService.create({
        key: activePixKey,
        amount: this.state.amount,
        additionalInformation: " ",
      });

      this.setState({
        qrCode: qrResponse?.data?.emvqrcps || "",
        qrCodeImageBase64: qrResponse?.data?.qrcodeImageBase64 || "",
        load: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({ load: false });
    }
  }

  updateValueTransfer(value) {
    const that = this;
    this.setState({ amount: Number(value), load: true }, () => {
      that.updateData();
    });
  }

  handleChange = (event) => {
    this.setState({ pixKey: event.target.value });
  };

  copyToClipboard = () => {
    if (!this.state.load) {
      navigator.clipboard
        .writeText(this.state.qrCode)
        .then(() => {
          return toast(this.state.translations.qrCodeCopiedSuccessfully, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "success",
            theme: "light",
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  render() {
    const hideDepositQrCard = this.isDepositQrBlocked();

    return (
      <section
        className="AccountInfoComponent"
        id="AccountInfoComponent"
        style={isMutual() ? { width: "700px" } : {}}
      >
        <div style={{ display: "flex" }}>
          <div>
            <div style={{ display: "flex" }}>
              <span>
                <b>{this.state.translations.account_information}</b>
                <br />
                <br />
                Banco: {FIXED_BANK_CODE}
                <br />
                Conta: {sessionStorage.getItem("account")}
                <br />
                Agência: {sessionStorage.getItem("agency")}
                <br />
                Chave Pix: {this.state.pixKey || "-"}
              </span>
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              display: "block",
              marginLeft: "auto",
              justifyContent: "center",
            }}
          >
            {!hideDepositQrCard && (
              <>
                <div style={{ display: "flex" }}>
                  <b>
                    {this.state.translations.how_much_will_you_receive + "? "}
                  </b>
                  <NumericFormat
                    className="input"
                    value={this.state.amount}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    prefix="R$ "
                    onValueChange={(values) => {
                      const { value } = values;
                      this.updateValueTransfer(value);
                    }}
                  />
                </div>
                <div className="contentItem">
                  {!this.state.load &&
                    this.state.hasPixKey &&
                    isMutual() &&
                    !isMtBank() &&
                    this.state.qrCodeImageBase64 && (
                      <img
                        src={`data:image/png;base64,${this.state.qrCodeImageBase64}`}
                        alt="QrCode"
                        width={"180px"}
                      />
                    )}

                  {!this.state.load &&
                    this.state.hasPixKey &&
                    (!isMutual() ||
                      isMtBank() ||
                      !this.state.qrCodeImageBase64) && (
                      <QRCodeCanvas
                        className="QRCodeCanvas"
                        id="qrCode"
                        value={this.state.qrCode}
                        size={100}
                        bgColor={"#ffffff"}
                        level={"H"}
                      />
                    )}

                  {!this.state.load && !this.state.hasPixKey && (
                    <div
                      style={{
                        maxWidth: "220px",
                        fontSize: "14px",
                        color: "#696C70",
                        margin: "0 auto",
                      }}
                    >
                      Nenhuma chave Pix ativa disponível para gerar QR Code.
                    </div>
                  )}

                  {this.state.load && (
                    <div class="loader">
                      <div class="spinner"></div>
                    </div>
                  )}
                </div>

                <div style={{ display: "flex" }}>
                  {!this.state.load && this.state.hasPixKey && (
                    <button
                      onClick={() => {
                        this.copyToClipboard();
                      }}
                      className="w-full px-4 py-2 backgroundPrimary text-white rounded"
                    >
                      {this.state.translations.copy}
                    </button>
                  )}
                  {!this.state.load && !this.state.hasPixKey && (
                    <button
                      onClick={() => {
                        window.location.href = "/transfers/pix";
                      }}
                      className="w-full px-4 py-2 backgroundPrimary text-white rounded"
                    >
                      Criar chave Pix
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <ToastContainer />
      </section>
    );
  }
}

export default Item;
